import React from 'react';
import './App.css';
import './styles/auth-theme.css';
import { AuthProvider, useAuth } from './auth/AuthContext.js';
import { AuthPage } from './pages/AuthPage.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { LogoutPage } from './pages/LogoutPage.js';

function AppContent(): React.JSX.Element {
  const { isAuthenticated, isLoading, user, error, updateProfile, signOut } = useAuth();

  if (window.location.pathname === '/logout') {
    return <LogoutPage />;
  }

  if (isLoading) {
    return <div />;
  }

  if (!isAuthenticated) {
    return <AuthPage />;
  }

  if (user) {
    return <DashboardPage email={user.email} profile={user.profile} error={error} onUpdateProfile={updateProfile} onSignOut={() => void signOut()} />;
  }

  throw new Error('Authenticated but no user object available');
}

export function App(): React.JSX.Element {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
